{
    "titleMyDocWithActivePseudo": "Mes annonces avec des transactions actives avec {aPseudo}",
    "titleDocCreatedByPseudo": "Annonces créées par {aPseudo} avec des transactions actives avec moi",
    "titleNoTransaction": "Aucune transaction active avec cette personne.",
    "removeThePerson": "Vous pouvez retirer cette personne de votre liste de contacts.",
    "removeThePersonButton": "Retirer",
    "removeThePersonButtonTitle": "Retirer cette personne de votre liste de contacts."
}